import React from 'react'
import { AzureAD, AuthenticationState } from 'react-aad-msal'
import { authProvider } from '../../services/authProvider'
import { Row } from 'reactstrap'
import store from '../../store/configureStore'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'

const Dashboard = (props) => {
  return (
    <AzureAD provider={authProvider} reduxStore={store}>
      {({ accountInfo }) => {
        return (
          <PageContainer>
            <PageHeading>User Manager</PageHeading>
            <Row style={{ marginLeft: '0px', fontSize: '1.25em' }}>Hey {accountInfo.account.name}, Welcome Back.</Row>
            <Row style={{ marginLeft: '0px', marginTop: '30px' }}>
              You can check out the documentation{' '}
              <a
                href="https://ositau.sharepoint.com"
                rel="noopener noreferrer"
                target="_blank"
                style={{ marginLeft: '2px' }}
              >
                here.
              </a>
            </Row>
            <Row style={{ marginLeft: '0px', marginTop: '5px' }}>
              If you run into any issues, log them{' '}
              <a style={{ marginLeft: '2px' }} href="mailto:bs@osit.com">
                {' '}
                here.
              </a>
            </Row>
          </PageContainer>
        )
      }}
    </AzureAD>
  )
}

export default Dashboard
